<template>
  <div class="mb-5">
    <b-row>
      <b-col>
        <div class="mt-1">
          <span class="pagination-indicator"
            >{{ currentFirstItem }}-{{ currentLastItem }} of
            {{ pagination.maxPage }} page</span>
            <b-pagination
              hide-goto-end-buttons
              align="left"
              size="md"
              class="custom-pagination-arrow-only mb-0 ml-2"
              :total-rows="totalRows"
              :limit="3"
              :per-page="10"
              v-model="pagination.currentPage"
              @change="paginate"
            >
            </b-pagination>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import _ from "lodash";

export default defineComponent({
  setup(props, { emit, root }) {
    const pagination = computed(
      () => root.$store.state.storeDineIn.pagination || {}
    );

    const currentFirstItem = computed(() => {
      if (!_.isEmpty(pagination.value))
        return 10 * pagination.value.previousPage + 1;
      else return 0;
    });

    const currentLastItem = computed(() => {
      if (!_.isEmpty(pagination.value)) return currentFirstItem.value + 10 - 1;
      else return 0;
    });

    const totalRows = computed(() => {
      if (!_.isEmpty(pagination.value)) return pagination.value.maxPage * 10;
      else return 0;
    });

    const paginate = (page) => {
      emit("setPagination", page);
    };

    return {
      pagination,
      currentFirstItem,
      currentLastItem,
      totalRows,
      paginate,
    };
  },
});
</script>
